if (!customElements.get('atomic-routine-timeline')) {
  customElements.define('atomic-routine-timeline', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const section = this.closest('.la-routine-timeline');
      const steps = [...this.querySelectorAll('[data-routine-step]')];
      const video = this.querySelector('video');
      const controls = this.querySelector('.la-routine-timeline__controls');
      const play = this.querySelector('[data-routine-play]');
      const mute = this.querySelector('[data-routine-mute]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manuallyPaused = false;
      let videoVisible = false;

      const selectStep = (index) => {
        steps.forEach((step, i) => {
          step.classList.toggle('is-reached', i <= index);
          const button = step.querySelector('[data-step-button]');
          if (i === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      };
      steps.forEach((step, i) => step.querySelector('button').addEventListener('click', () => selectStep(i), options));
      this.stepObserver = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length) selectStep(Math.max(...visible.map((entry) => steps.indexOf(entry.target))));
      }, { rootMargin: '-25% 0px -40% 0px', threshold: 0 });
      steps.forEach((step) => this.stepObserver.observe(step));
      section.classList.add('is-enhanced');

      const updateControls = () => {
        play.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} conversation video`);
        mute.setAttribute('aria-label', `${video.muted ? 'Unmute' : 'Mute'} conversation video`);
        this.querySelector('[data-play-icon]').toggleAttribute('hidden', !video.paused);
        this.querySelector('[data-pause-icon]').toggleAttribute('hidden', video.paused);
        this.querySelector('[data-muted-icon]').toggleAttribute('hidden', !video.muted);
        this.querySelector('[data-sound-icon]').toggleAttribute('hidden', video.muted);
      };
      const autoplayWhenVisible = () => {
        if (videoVisible && !document.hidden && !manuallyPaused && !reducedMotion.matches) {
          video.play().catch(updateControls);
        } else if (!videoVisible || document.hidden || reducedMotion.matches) {
          video.pause();
        }
      };
      video.muted = true;
      video.controls = false;
      controls.hidden = false;
      ['play', 'pause', 'volumechange'].forEach((event) => video.addEventListener(event, updateControls, options));
      play.addEventListener('click', () => {
        manuallyPaused = !video.paused;
        if (video.paused) video.play().catch(updateControls);
        else video.pause();
      }, options);
      mute.addEventListener('click', () => { video.muted = !video.muted; }, options);
      document.addEventListener('visibilitychange', autoplayWhenVisible, options);
      reducedMotion.addEventListener('change', autoplayWhenVisible, options);
      this.videoObserver = new IntersectionObserver(([entry]) => {
        videoVisible = entry.isIntersecting;
        autoplayWhenVisible();
      }, { threshold: 0.2 });
      this.videoObserver.observe(video);
      updateControls();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.stepObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
